import { useTranslateEnum } from '@festina-life/ui/hooks'
import cx from 'classnames'

import { useLayoutContext } from '../../context/layoutContext'
import {
  ConfigurationFieldType,
  isSubTemplatedField,
  type TemplateField,
} from '../../types/templateModel'
import { useFieldDocumentation } from '../templateFieldDocumentation/useFieldDocumentation'
import { TemplateFieldConfig } from './TemplateFieldConfig'

type Props = {
  field: TemplateField
  isCentered?: boolean
  isExpanded?: boolean
}

export const TemplateFieldType = ({
  field,
  isExpanded = false,
  isCentered = true,
}: Props) => {
  const { modelFieldType } = useFieldDocumentation(field)
  const {
    preferences: {
      templates: { isShowingEmptyValues },
    },
  } = useLayoutContext()
  const translateEnum = useTranslateEnum()

  return (
    <div className={cx('flex flex-col', { 'items-center': isCentered })}>
      <div>{modelFieldType}</div>
      {field.fieldType !==
        ConfigurationFieldType.ConfigurationExpressionValue && (
        <TemplateFieldConfig field={field} isExpanded={isExpanded} />
      )}
      {!field.value && isSubTemplatedField(field) && isShowingEmptyValues && (
        <div>{translateEnum('enum.ValueSetupRole', field.role)}</div>
      )}
    </div>
  )
}
